export default __webpack_public_path__ + "static/media/single-project-page-01-img3.ee37b820.jpg";